import {
  Barcode,
  ClipboardCheck,
  ClipboardList,
  FileCode2,
  FileSpreadsheet,
  FileText,
  Hash,
  HelpCircle,
  Inbox,
  Layers,
  LayoutDashboard,
  List,
  Printer,
  Radio,
  RotateCcw,
  ScanBarcode,
  ScanLine,
  Settings,
  Tag,
  type LucideIcon,
} from "lucide-react";

export type MenuItemDef = {
  titleKey: string;
  url: string;
  icon: LucideIcon;
};

export type MenuSectionDef = {
  labelKey: string;
  items: MenuItemDef[];
};

// Fonte única de verdade do menu lateral.
// Usada tanto pela sidebar (AppSidebar) quanto pela tela de configurações,
// onde o admin escolhe quais botões ficam visíveis para o cliente.
// As chaves i18n são traduzidas no componente que consome.
export const MENU_SECTIONS: MenuSectionDef[] = [
  {
    labelKey: "nav.sections.operacao",
    items: [
      { titleKey: "nav.items.inicio", url: "/", icon: LayoutDashboard },
      { titleKey: "nav.items.etiquetas", url: "/etiquetas", icon: Tag },
      {
        titleKey: "nav.items.conferirEtiqueta",
        url: "/conferir-etiqueta",
        icon: ScanLine,
      },
      {
        titleKey: "nav.items.logsImpressao",
        url: "/logs-impressao",
        icon: FileText,
      },
      {
        titleKey: "nav.items.filaImpressao",
        url: "/fila-impressao-socket",
        icon: Inbox,
      },
    ],
  },
  {
    labelKey: "nav.sections.impressao",
    items: [
      {
        titleKey: "nav.items.impressaoAvulsa",
        url: "/impressao-avulsa",
        icon: Printer,
      },
      {
        titleKey: "nav.items.impressaoSscc",
        url: "/impressao-sscc",
        icon: Barcode,
      },
      {
        titleKey: "nav.items.impressaoBipagem",
        url: "/impressao-bipagem",
        icon: ScanBarcode,
      },
      {
        titleKey: "nav.items.reimprimirEtiqueta",
        url: "/reimprimir-etiqueta",
        icon: RotateCcw,
      },
    ],
  },
  {
    labelKey: "nav.sections.importacao",
    items: [
      {
        titleKey: "nav.items.importarPlanilha",
        url: "/importar-planilha",
        icon: FileSpreadsheet,
      },
      { titleKey: "nav.items.importarXml", url: "/importar-xml", icon: FileCode2 },
      {
        titleKey: "nav.items.importarPedidos",
        url: "/importar-pedidos",
        icon: ClipboardList,
      },
      { titleKey: "nav.items.importarOrdem", url: "/importar-ordem", icon: List },
    ],
  },
  {
    labelKey: "nav.sections.gravacao",
    items: [
      {
        titleKey: "nav.items.gravacaoAvulsa",
        url: "/gravacao-avulsa",
        icon: Radio,
      },
    ],
  },
  {
    labelKey: "nav.sections.configuracao",
    items: [
      { titleKey: "nav.items.serializacao", url: "/serializacao", icon: Hash },
      {
        titleKey: "nav.items.testadorModulo",
        url: "/testador-modulo",
        icon: ClipboardCheck,
      },
      {
        titleKey: "nav.items.perfilPreferencia",
        url: "/perfil-de-preferencia",
        icon: Layers,
      },
      {
        titleKey: "nav.items.preferencias",
        url: "/preferencias",
        icon: Settings,
      },
    ],
  },
  {
    labelKey: "nav.sections.ajuda",
    items: [
      {
        titleKey: "nav.items.documentacao",
        url: "/documentacao",
        icon: HelpCircle,
      },
    ],
  },
];

// Botões que nunca podem ser ocultados — senão o admin se tranca fora:
// "Início" é a porta de entrada e "Preferências" dá acesso a esta própria tela.
export const PROTECTED_MENU_URLS: string[] = ["/", "/preferencias"];
